import { useEffect, useState, useCallback } from "react";
import { api } from "../lib/api";
import { toast } from "sonner";
import { Zap, Bell, Send, Loader2 } from "lucide-react";

const TYPE_BADGE = { envoi: { l: "Envoi auto", c: "bg-emerald-600/30 text-emerald-200" }, alerte: { l: "Alerte", c: "bg-amber-600/30 text-amber-200" } };

export default function AutomatisationsModule() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    setLoading(true);
    try { const { data } = await api.get("/accueil-pilotage/automations"); setRows(data.automations || []); }
    catch { toast.error("Chargement échoué."); }
    setLoading(false);
  }, []);
  useEffect(() => { load(); }, [load]);

  const toggle = async (a) => {
    if (!a.toggleable) return;
    try { await api.put(`/accueil-pilotage/automations/${a.key}`, { enabled: !a.enabled }); toast.success(!a.enabled ? "Automatisation activée" : "Automatisation désactivée"); load(); }
    catch (e) { toast.error(e.response?.data?.detail || "Erreur"); }
  };

  if (loading) return <div className="min-h-[60vh] flex items-center justify-center text-zinc-400"><Loader2 className="animate-spin mr-2" /> Chargement…</div>;

  return (
    <div className="max-w-4xl mx-auto px-4 py-6 space-y-5" data-testid="automatisations-page">
      <div>
        <div className="text-[#C9A961] text-xs uppercase tracking-widest">Accueil & Pilotage</div>
        <h1 className="text-3xl font-bold text-white flex items-center gap-2"><Zap className="w-7 h-7 text-[#C9A961]" /> Automatisations</h1>
        <p className="text-zinc-400 text-sm mt-1">Active ou désactive les rappels et alertes automatiques. Tu gardes le contrôle total.</p>
      </div>

      <div className="space-y-3" data-testid="automations-list">
        {rows.map((a) => {
          const tb = TYPE_BADGE[a.type] || TYPE_BADGE.envoi;
          return (
            <div key={a.key} className="rounded-2xl border border-white/10 bg-white/[0.03] p-4 flex items-start justify-between gap-4" data-testid={`automation-${a.key}`}>
              <div className="min-w-0">
                <div className="flex items-center gap-2 flex-wrap">
                  {a.type === "alerte" ? <Bell className="w-4 h-4 text-amber-400" /> : <Send className="w-4 h-4 text-emerald-400" />}
                  <span className="text-white font-semibold text-sm">{a.label}</span>
                  <span className={`text-[10px] px-1.5 py-0.5 rounded-full ${tb.c}`}>{tb.l}</span>
                </div>
                <p className="text-xs text-zinc-400 mt-1">{a.desc}</p>
                <div className="text-[11px] text-zinc-500 mt-1.5">
                  {a.last_run ? `Dernière exécution : ${new Date(a.last_run).toLocaleString("fr-CA")} · ${a.last_count || 0} envoi(s)` : "Pas encore exécutée"}
                </div>
              </div>
              <div className="shrink-0">
                {a.toggleable ? (
                  <button onClick={() => toggle(a)} data-testid={`automation-toggle-${a.key}`}
                    className={`relative w-12 h-7 rounded-full transition ${a.enabled ? "bg-emerald-500" : "bg-zinc-600"}`}>
                    <span className={`absolute top-1 w-5 h-5 rounded-full bg-white transition-all ${a.enabled ? "left-6" : "left-1"}`} />
                  </button>
                ) : (
                  <span className="text-[11px] px-2 py-1 rounded-full bg-sky-600/20 text-sky-300" data-testid={`automation-always-${a.key}`}>Toujours active</span>
                )}
              </div>
            </div>
          );
        })}
      </div>

      <p className="text-[11px] text-zinc-600">Note : l'envoi réel des courriels/SMS dépend de la configuration Resend/Twilio en production.</p>
    </div>
  );
}
